import Home from '../components/Home';
import PageLayout from '../components/pageLayout';

function HomePage() {
  return (
    <PageLayout children={<Home />} componentName="Home" />
  );
}

export default HomePage;
